import React, { useContext, useEffect, useState } from 'react'
import { CloseChatContext } from './ComplateMessages'
import Rating from '@material-ui/lab/Rating';
import Typography from '@material-ui/core/Typography';

function ChatFooter() {
    const { state, dispatch } = useContext(CloseChatContext)

    const initialState = (
        <div className="card-footer chat-form" style={{ backgroundColor: '#ffff' }}>
            <form id="chat-form2" >
                <div style={{ height: '50px' }}></div>
            </form>
        </div>
    )
    const [renderFooter, setrenderFooter] = useState(initialState)
    useEffect(() => {
        if (state.active != null) {
            const chat = state.chats.find(chat => chat.id == state.active)

            function renderStar(count) {
                const star = []
                for (var i = 0; i < 5; i++) {
                    star.push(<i className="fas fa-star ml-2" style={{ fontSize: '2em', color: `${i < count ? 'yellow' : '#fff'}`, textShadow: '-1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000' }} key={i} />)
                }
                return star
            }
            setrenderFooter(
                <div className="card-footer chat-form container p-1" style={{ maxHeight: '200px' }}>
                    <div className="row justify-content-md-center">
                        <div className="col col-lg-8 col-md-8 col-sm-12">
                            <div className="form-group">
                                <Typography component="legend">Rating</Typography>
                                {chat.ratting != null ? (
                                    renderStar(chat.ratting)
                                ) : (
                                    <div className="alert alert-light" style={{ fontWeight: 'bold' }}>User has not yet given a rating.</div>
                                )}
                            </div>
                            <div className="form-group">
                                <Typography component="legend">Feedback</Typography>
                                {chat.ratting != null ? (
                                    <textarea name="feedback" className="form-control" value={chat.feedback != null ? chat.feedback : ''} style={{ height: '75px', border: 'solid' }} placeholder="Type your feedback here" readOnly></textarea>
                                ) : (
                                    <div className="alert alert-light" style={{ fontWeight: 'bold' }}>
                                        Users have not provided feedback.
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )
        } else {
            setrenderFooter(initialState)
        }
    }, [state.active])
    return (renderFooter)
}

export default ChatFooter
